<template>
  <div class="home-content-box about-box">
    <div class="background-white-box left-box right-top-radius" />
    <div class="home-content-body body-max-container">
      <ul>
        <li>
          <div class="home-content-info">
            <div class="home-content-info-body">
              <div class="title">關於我們</div>
              <div class="subTitle">About</div>
              <div class="content">
                <span>{{ getAboutInfo }}</span>
              </div>
            </div>
            <div class="enter-btn" @click="goAbout">
              <img src="../../../assets/img/icon-arrow-right.svg" alt />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeAbout",
  data() {
    return {
      aboutText:
        "導演Raye在學生時期曾到過收容所，與同學試圖挽救即將被撲殺的小生命，雖然最終她救的小狗們不幸得了犬瘟離開了，卻在她的心中埋下一顆種子，期盼著有一天能憑藉自己的力量，喚起大家對流浪動物的關心的種子。",
    };
  },
  computed: {
    getAboutInfo() {
      return window.config.about_info ? window.config.about_info.replace(/<br>/g, '') : ""
    }
  },
  methods: {
    goAbout() {
      this.$router.push({ name: "About" });
    },
  },
};
</script>

<style lang="scss" scoped>
.about-box {
  //margin-top: 100vh;
  .enter-btn {
    img {
      bottom: 20% !important;
    }
  }
}
</style>
